import { useEffect, useState } from "react";
import classes from "./ChallengeEnrollment.module.css";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import CommonButton from "../../ui/CommonButton";
import { env } from "../../constants/env";
import axios from "axios";
import SentIcon from "../../icon/SentIcon";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";

const steps = [
  "Once you enroll, you secure your spot and logins get synced at the start date of the challenge",
  "All traders in a cohort start the challenge at the same time",
  "There’s no time limit to hit the target, the challenge only expires once all the funding slots are filled in your cohort",
  "If you end in profit you get a free slot into the next months cohort",
];


const EvaluationType = ({ selected, setSelected }) => {
  const [oneStepSoldOut, setOneStepSoldOut] = useState(false);
  const [twoStepSoldOut, setTwoStepSoldOut] = useState(false);

   useEffect(() => {
    const fetchSlotData = async () => {
      try {
        const response = await axios.get(`${env.apiUrl}/api/user/slots`);
        if(response.data.oneStepRemaining === 0){
          setOneStepSoldOut(true);
        }
        if(response.data.twoStepRemaining === 0){
          setTwoStepSoldOut(true);
        }
      } catch (err) {
        console.error("Failed to fetch slot data:", err);
      }
    };

    fetchSlotData();
  }, []);
  return (
    <div className={`${classes.evaluationTypeWrapper}`}>
      <h4 className={`${classes.label} mb-4`}>Evaluation Type</h4>

      <div
        className={`${classes.toggleContainer} d-flex justify-content-between align-items-center`}
      >
        {/* 1-Step Button */}
        <button
          className={`${classes.typeOption} ${
            selected === "1-Step" ? classes.activeType : ""
          } ${oneStepSoldOut ? classes.soldOutType : ""} position-relative`}
          onClick={() => setSelected("1-Step")}
          disabled={oneStepSoldOut}
        >
          1 - Step
          {oneStepSoldOut && <span className={classes.soldOutTag}>Sold out</span>}
        </button>

        <div className={`${classes.divider} ${selected ? classes.transparentBorder : ""}`}></div>

        {/* 2-Step Button */}
        <button
          className={`${classes.typeOption} position-relative ${
            selected === "2-Step" ? classes.activeType : ""
          } ${twoStepSoldOut ? classes.soldOutType : ""}`}
          onClick={() => setSelected("2-Step")}
          disabled={twoStepSoldOut}
        >
          2 - Step
         
          {twoStepSoldOut ? <span className={classes.soldOutTagRight}>Sold out</span> : 
           <span className={classes.cheaperTag}>40% cheaper</span>}
        </button>
      </div>
    </div>
  );
};

const ChallengeEnrollment = ({
  setShowSuccess,
  setShowPurchase,
  activeAccountType,
}) => {
  const token = localStorage.getItem("userToken");
  const [accountSize, setAccountSize] = useState(null);
  const [agreed, setAgreed] = useState(false);
  const [selectedReferrer, setSelectedReferrer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedEvaluationType, setSelectedEvaluationType] = useState(null);
  const [evaluationTypeError, setEvaluationTypeError] = useState(false);

  const accountSizes = ["10K", "25K"];

  const handleEnterChallenge = async () => {
    if (!agreed || loading) return;

    try {
      setLoading(true);

      const response = await axios.post(
        `${env.apiUrl}/api/user/assign-slot`,
        {
          challengeType: selectedEvaluationType,
          accountSize,
          referrer: selectedReferrer?.value || "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Slot assigned:", response.data);
      setShowSuccess(true);
    } catch (error) {
      console.error(
        "Failed to assign slot:",
        error.response?.data || error.message
      );
      toast.error(
        "Could not assign a slot. It may be full or you're not logged in."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accountSize && !selectedEvaluationType) {
      setEvaluationTypeError(true);
    } else {
      setEvaluationTypeError(false);
    }
    
  }, [accountSize, selectedEvaluationType]);

  return (
    <div className={classes.wrapper}>
      <div>
        <button
          className={`${classes.closeButton} d-flex justify-content-center align-items-center`}
          onClick={() => setShowPurchase(false)}
        >
          <IoMdClose color="white" size={22} />
        </button>
        <EvaluationType selected={selectedEvaluationType} setSelected={setSelectedEvaluationType} />
        <div className={classes.modal}>
          {/* Left section */}
          <div className={classes.left}>
            <div className={`${classes.accountSizeContainer} ${evaluationTypeError ? classes.dangerBorder : ""}`}>
              <h4 className={`${classes.label} mb-4`}>Account Size</h4>
              <div className={classes.accountOptions}>
                {accountSizes.map((size) => (
                  <button
                    key={size}
                    className={`${classes.accountSizeButton} ${
                      accountSize === size ? classes.active : ""
                    }`}
                    onClick={() => !selectedEvaluationType ? setEvaluationTypeError(true) : setAccountSize(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>
              <p className={classes.errorText}>{evaluationTypeError && "Please select an evaluation type."}</p>
            </div>

            <CustomDropdown
              label="Who referred you?"
              value={selectedReferrer}
              onChange={setSelectedReferrer}
              options={[
                { value: "Team-pow.com", label: "Team-pow.com" },
                { value: "Archfunding.ai", label: "Archfunding.ai" },
                { value: "KMR.Trade", label: "KMR.Trade" },
                { value: "M1", label: "M1" },
                { value: "SHIM", label: "SHIM" },
                { value: "Tradify Fx", label: "Tradify Fx" },
                { value: "Claudiu Popa", label: "Claudiu Popa" },
              ]}
              placeholder="Select referrer"
              inputClass={classes.inputContainer}
              className="mb-4"
            />

            <div className={classes.checkboxRow}>
              <input
                type="checkbox"
                checked={agreed}
                onChange={() => setAgreed(!agreed)}
              />
              <span>
                I agree to Propfunding’s{" "}
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  terms of service
                </a>
              </span>
            </div>

            <CommonButton
              text={loading ? "Entering..." : "Enter free"}
              disabled={!agreed || loading || !accountSize || !selectedEvaluationType}
              className="w-100 mt-3"
              onClick={handleEnterChallenge}
            />
          </div>

          {/* Right section */}
          <div className={classes.right}>
            <div className={classes.stepsContainer}>
              <h4 className={classes.heading}>What Happens Next?</h4>
              <ul className={classes.steps}>
                {steps.map((item, i) => (
                  <li>
                    <div className=" d-flex gap-2" key={i}>
                      <SentIcon /> <p>{item}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeEnrollment;
